var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isBasicInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBasicInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Serviceability",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Serviceability")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "col1-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Truck Load Type :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.TruckLoadType))]), _vm._v(" "), _c('th', [_vm._v("Route Mode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.RouteMode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("PickUp PinCode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PickupPincode))]), _vm._v(" "), _c('th', [_vm._v("Destination PinCode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DestinationPincode))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Origin Hub :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.OriginHub))]), _vm._v(" "), _c('th', [_vm._v("Destination Hub :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DestinationHub))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Booking Mode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.BookingMode))]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RouteMode == 'Air' && _vm.BookingMode == 'Prepaid'),
      expression: "RouteMode == 'Air' && BookingMode == 'Prepaid'"
    }]
  }, [_c('th', [_vm._v("Business Type :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.businesstype))]), _vm._v(" "), _c('th', [_vm._v("Airline :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.airlinename))])]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RouteMode == 'Air' && _vm.BookingMode == 'Prepaid'),
      expression: "RouteMode == 'Air' && BookingMode == 'Prepaid'"
    }]
  }, [_c('th', [_vm._v("Product Type :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.producttype))]), _vm._v(" "), _c('th', [_vm._v("Flight Type :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.flighttype))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "PickupLocation",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "col1-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Shipment drop to hub by client :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.ShipmentDropByClient))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("PinCode :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PinCode))]), _vm._v(" "), _c('th', [_vm._v("City :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.City))]), _vm._v(" "), _c('th', [_vm._v("State :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.State))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("Location Name :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.LocationName))]), _vm._v(" "), _c('th', [_vm._v("Mobile :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Mobile))]), _vm._v(" "), _c('th', [_vm._v("Telephone :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Telephone))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Email))]), _vm._v(" "), _c('th', [_vm._v("Address :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.Address))]), _vm._v(" "), _c('th', [_vm._v("GST No :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.PickupGST))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ShipmentDetails",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "col1-md-12"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Number of invoices :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "5%"
    }
  }, [_vm._v(_vm._s(_vm.NumberOfInvoice))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Total Shipment Declared Value (INR) :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.TotalShipmentValue))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Requested PickUp Date :")]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v(_vm._s(_vm.RequestedPickupDate))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Number of MPS :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.NumberOfMPS))]), _vm._v(" "), _c('th', [_vm._v("Total Shipment Declared Weight (kg) :")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.TotalShipmentWeight))]), _vm._v(" "), _c('th', [_vm._v("Requested PickUp Time (hrs) :")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(" From : ")]), _vm._v(_vm._s(_vm.RequestedPickupTimeFrom) + "    "), _c('strong', [_vm._v("To : ")]), _vm._v(" " + _vm._s(_vm.RequestedPickupTimeTo))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "200px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("S.N.")]), _vm._v(" "), (_vm.boxTypeshow) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("Product")]) : _vm._e(), _vm._v(" "), (_vm.boxTypeshow) ? _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "10%"
    }
  }, [_vm._v("Box Type")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "3",
      "scope": "colgroup",
      "width": "50%"
    }
  }, [_vm._v("Box Dimensions (cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Avg Volumetric Wt per MPS (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "2",
      "width": "12%"
    }
  }, [_vm._v("Number of"), _c('br'), _vm._v(" boxes")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Breadth")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Height")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.boxTypeshow) ? _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v(_vm._s(data.skulist))]), _vm._v(" "), (data.skulist == 'Other') ? _c('div', [_vm._v(_vm._s(data.otherskuname))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.boxTypeshow) ? _c('td', {
      staticClass: "text-center"
    }, [_c('div', [_vm._v(_vm._s(data.boxtype))]), _vm._v(" "), (data.boxtype == 'Other') ? _c('div', [_vm._v(_vm._s(data.otherboxname))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxdimension.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxdimension.breadth))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.boxdimension.height))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.averagevolumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofboxes))])])
  }))])])])], 1)])])])])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b64bf70","hasScoped":true}!./src/modules/cargobooking/views/booking/bookingListing/bookingview/basicinformation/basicinformation.component.html
// module id = 1192
// module chunks = 3